var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/menu/common/src/base-state-view-model.ts
import { isBrowser, KeyHelpers } from "@gs-ux-uitoolkit-common/shared";

// components/menu/common/src/state-view-model-controller.ts
var _StateViewModelController = class _StateViewModelController {
  constructor() {
    if (_StateViewModelController.instance) {
      return _StateViewModelController.instance;
    }
    _StateViewModelController._instance = this;
  }
  static get instance() {
    return this._instance;
  }
  isFocussed(vm) {
    return this.focussed === vm;
  }
  focus(vm) {
    this.blur();
    this.focussed = vm;
    this.focussed.setupBlurHandler();
  }
  blur(vm) {
    if (vm && this.focussed === vm || !vm && this.focussed) {
      this.focussed.cancelBlurHandler();
      this.focussed = void 0;
    }
  }
};
_StateViewModelController._instance = new _StateViewModelController();
var StateViewModelController = _StateViewModelController;

// components/menu/common/src/menu-event.ts
var MenuEvent = class {
  constructor(props) {
    this.menuElement = props.menuElement;
  }
};
var MenuBlurEvent = class extends MenuEvent {
  constructor(props) {
    super(props);
    this.nextActiveElement = props.nextActiveElement;
    this.input = props.input;
  }
};

// components/menu/common/src/window.ts
function hasWindow() {
  return "undefined" !== typeof window;
}
function hasDocument() {
  return "undefined" !== typeof document;
}

// components/menu/common/src/base-state-view-model.ts
var BaseStateViewModel = class {
  constructor(baseProps) {
    this.menuEl = null;
    this.childrenContainerEl = null;
    this.submenuVisible = false;
    // `children` are direct MenuOption children.
    this.children = [];
    // `addedChildren` are children of child menus, such as a child CollapseMenu.
    this.addedChildren = [];
    this.focusIndex = -1;
    this.submenuParentIndex = -1;
    this.addChildren = (children, afterElement, autoFocus = false) => {
      const afterIndex = this.addedChildren.findIndex(
        (added) => added.afterElement === afterElement
      );
      if (afterIndex !== -1) {
        this.addedChildren.splice(afterIndex, 1);
      }
      this.addedChildren.push({ children, afterElement });
      this.updateChildren();
      if (autoFocus) {
        children.some((child) => {
          const index = this.children.indexOf(child);
          if (index !== -1) {
            this.focusIndex = index;
            this.focusChildOnMenuFocus();
            return true;
          }
          return false;
        });
      }
    };
    this.removeChildren = (afterElement) => {
      const afterIndex = this.addedChildren.findIndex(
        (added) => added.afterElement === afterElement
      );
      if (afterIndex !== -1) {
        this.addedChildren.splice(afterIndex, 1);
      }
      this.updateChildren();
    };
    this.props = __spreadValues({}, baseProps);
    this.svmCtrl = StateViewModelController.instance;
    this.onWindowBlur = this.onWindowBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }
  update(props) {
    this.props = this.updateProps(props);
  }
  destroy() {
    this.cancelBlurHandler();
  }
  setMenuEl(value) {
    this.menuEl = this.childrenContainerEl = value;
    if (this.props.visible) {
      this.focusChildOnMenuFocus();
    }
  }
  getMenuEl() {
    return this.menuEl;
  }
  setSubmenuVisible(value) {
    this.submenuParentIndex = value ? this.getFocusIndex() : -1;
    this.submenuVisible = value;
  }
  getSubmenuVisible() {
    return this.submenuVisible;
  }
  setupBlurHandler() {
    if (hasWindow()) {
      window.addEventListener("mousedown", this.onWindowBlur);
      window.addEventListener("blur", this.onWindowBlur);
      window.addEventListener("keydown", this.onKeyDown);
    }
  }
  cancelBlurHandler() {
    if (hasWindow()) {
      window.removeEventListener("mousedown", this.onWindowBlur);
      window.removeEventListener("blur", this.onWindowBlur);
      window.removeEventListener("keydown", this.onKeyDown);
    }
  }
  /**
   * Focuses the Menu and, if autoFocus is enabled, the first option child.
   * If @param element is defined, a child option that is or contains that
   * element will be focussed; this is necessary in certain cases including
   * when an option that opens a submenu is toggled, thus closing the
   * submenu and focussing this menu, in which case the focus should be placed
   * not on the first child option but on the child option that was clicked.
   */
  focus(element) {
    if (this.svmCtrl.isFocussed(this)) {
      return;
    }
    this.svmCtrl.focus(this);
    if (this.props.visible) {
      this.updateChildren();
      if (this.hasChildren()) {
        if (element) {
          const index = this.getIndexForChildWithElement(element);
          this.focusIndex = index === -1 ? this.focusIndex : index;
        }
        if (this.focusIndex !== -1 || this.props.autoFocus) {
          this.focusChildOnMenuFocus();
        }
      }
    }
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }
  isVisible() {
    return this.props.visible || false;
  }
  // Calls onBlur if a click/touch occurs outside of the menu element, which
  // should correspond to the menu being blurred.
  onWindowBlur(event) {
    if (!this.menuEl)
      return;
    if (hasWindow() && event.target === window || event.target && event.target !== this.menuEl && !this.menuEl.contains(event.target)) {
      this.callOnBlur(this.getBlurEvent(event.target, "pointer"));
    }
  }
  onKeyDown(event) {
    this.respondToKeyDown(event);
  }
  // Returns true if action taken, false otherwise, allowing onKeyDown to be
  // overridden by an extending class but only perform an action if
  // respondToKeyDown returns false.
  respondToKeyDown(event) {
    if (!this.svmCtrl.isFocussed(this)) {
      return true;
    }
    const regex = /^[\w-_.]$/;
    if (regex.test(event.key)) {
      this.focusNext(event.key.toLowerCase());
      return true;
    }
    switch (event.which) {
      case KeyHelpers.keyCode.TAB:
        event.preventDefault();
        return true;
      case KeyHelpers.keyCode.ESCAPE:
        this.callOnBlur(this.getBlurEvent(event.target, "keyboard"));
        return true;
      case KeyHelpers.keyCode.ARROW_DOWN:
        this.onFocusDirection(event, "down");
        return true;
      case KeyHelpers.keyCode.ARROW_UP:
        this.onFocusDirection(event, "up");
        return true;
      case KeyHelpers.keyCode.ARROW_LEFT:
        if (this.props.isSubmenu) {
          this.callOnBlur(this.getBlurEvent(event.target, "arrow"));
          return true;
        }
        break;
      default:
        break;
    }
    return false;
  }
  onFocusDirection(event, direction) {
    event.preventDefault();
    this.updateChildren();
    if (this.hasChildren()) {
      this.focusIndex = this.getFocusIndex();
      if (direction === "up") {
        this.focusUp();
      } else {
        this.focusDown();
      }
    }
  }
  focusDown() {
    while (this.focusIndex < this.children.length - 1) {
      this.focusIndex += 1;
      const child = this.children[this.focusIndex];
      if (this.isElementFocusable(child)) {
        child.focus();
        return true;
      }
    }
    return false;
  }
  focusUp() {
    while (this.focusIndex > 0) {
      this.focusIndex -= 1;
      const child = this.children[this.focusIndex];
      if (this.isElementFocusable(child)) {
        child.focus();
        return true;
      }
    }
    return false;
  }
  focusNext(char) {
    var _a;
    const eligibleChildren = this.children.filter((element) => {
      var _a2, _b;
      const labelSpan = element.querySelector(
        ".gs-menu__option-label, .gs-checkbox__children"
      );
      return (_b = (_a2 = labelSpan == null ? void 0 : labelSpan.innerText) == null ? void 0 : _a2.toLowerCase()) == null ? void 0 : _b.startsWith(char);
    });
    if (eligibleChildren.length === 0)
      return;
    const currentFocus = (_a = document.activeElement) != null ? _a : eligibleChildren == null ? void 0 : eligibleChildren[0];
    const totalFocusable = (eligibleChildren || []).length;
    const focusedIndex = Math.max(
      Array.from(eligibleChildren).findIndex((el) => el === currentFocus),
      0
    );
    let elementToBeFocused;
    if (focusedIndex === totalFocusable - 1)
      elementToBeFocused = eligibleChildren[0];
    else
      elementToBeFocused = eligibleChildren[focusedIndex + 1];
    if (this.isElementFocusable(elementToBeFocused)) {
      elementToBeFocused.focus();
      return true;
    }
    return false;
  }
  getFocusIndex() {
    return this.children.findIndex(
      (el) => el === document.activeElement || el.contains(document.activeElement)
    );
  }
  callOnBlur(event) {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }
  getBlurEvent(eventTarget, input) {
    const nextActiveElement = eventTarget ? eventTarget : document.activeElement || document.body;
    return new MenuBlurEvent({ menuElement: this.getMenuEl(), nextActiveElement, input });
  }
  updateChildren() {
    if (this.childrenContainerEl) {
      this.children = Array.from(this.childrenContainerEl.children);
      this.addedChildren.forEach((added) => {
        const index = this.children.findIndex((child) => {
          return child === added.afterElement || this.props.isAngular && child.firstChild === added.afterElement;
        });
        if (index !== -1) {
          this.children.splice(index + 1, 0, ...added.children);
        }
      });
      this.children = this.children.map((el) => {
        if (this.isElementFocusable(el)) {
          return el;
        }
        if (this.props.isAngular && el.firstChild && this.isElementFocusable(el.firstChild)) {
          return el.firstChild;
        }
        return null;
      }).filter((el) => !!el).map((el) => el);
    } else {
      this.children = [];
    }
  }
  focusChildOnMenuFocus() {
    if (!this.hasFocussedChild() && !this.focusChildAtIndex(this.focusIndex)) {
      this.focusChildAtIndex(this.getFirstFocusableIndex());
    }
  }
  hasFocussedChild() {
    return this.children.some((child) => child === document.activeElement);
  }
  focusChild(child) {
    setTimeout(() => {
      const scrollY = window.scrollY;
      child.focus();
      if (window.scrollX !== void 0 && window.scrollY !== void 0) {
        window.scrollTo(window.scrollX, scrollY);
      }
    }, 1);
  }
  focusChildAtIndex(index) {
    if (index !== -1 && this.children[index]) {
      this.focusChild(this.children[index]);
      return true;
    }
    return false;
  }
  getFirstFocusableIndex() {
    for (let i = 0; i < this.children.length; i++) {
      if (this.isElementFocusable(this.children[i])) {
        return i;
      }
    }
    return -1;
  }
  getIndexForChildWithElement(element) {
    const eventIsOutsideDocument = isBrowser && window === element;
    return this.children.findIndex(
      (child) => eventIsOutsideDocument || child === element || child.contains(element)
    );
  }
  isElementFocusable(el) {
    if (el instanceof HTMLElement) {
      const tabIndexStr = el.getAttribute("tabindex");
      if (tabIndexStr) {
        return +tabIndexStr >= 0;
      }
    }
    return false;
  }
  hasChildren() {
    return this.children && this.children.length;
  }
  updateProps(props) {
    if (!props.visible && this.props.visible) {
      this.hide();
    }
    return __spreadValues(__spreadValues({}, this.props), props);
  }
  hide() {
    this.svmCtrl.blur(this);
  }
};

// components/menu/common/src/menu-state-view-model.ts
import {
  createPopper
} from "@popperjs/core";
var MenuStateViewModel = class extends BaseStateViewModel {
  constructor(menuProps) {
    super(menuProps);
    this.context = null;
    this.popper = null;
    this.props = this.updateProps(menuProps);
  }
  destroy() {
    super.destroy();
    this.destroyPopper();
  }
  setMenuEl(value) {
    this.menuEl = value;
    if (this.menuEl) {
      const innerElIndex = Array.from(this.menuEl.children).findIndex(
        (el) => el instanceof HTMLElement
      );
      this.childrenContainerEl = innerElIndex === -1 ? null : this.menuEl.children[innerElIndex];
      this.destroyPopper();
      this.createPopper();
    } else {
      this.destroyPopper();
    }
  }
  update(props) {
    this.props = this.updateProps(props);
    if (this.props.visible) {
      this.createPopper();
    } else {
      this.destroyPopper();
    }
  }
  focus(element) {
    if (this.popper) {
      super.focus(element);
    }
  }
  // Creates an element to use as a reference target if one is not provided by
  // the user. Useful for opening a context menu at specific coordinates.
  createContext() {
    this.context = document.createElement("div");
    this.context.setAttribute("data-cy", "gs-uitk-menu__context");
    this.context.style.position = "fixed";
    this.moveContext();
    document.body.appendChild(this.context);
    return this.context;
  }
  moveContext() {
    if (this.context) {
      const contextOffset = Array.isArray(this.props.offset) ? this.props.offset : [0, 0];
      this.context.style.left = `${contextOffset[0]}px`;
      this.context.style.top = `${contextOffset[1]}px`;
    }
  }
  destroyContext() {
    if (this.context && this.context.parentElement) {
      this.context.parentElement.removeChild(this.context);
      this.context = null;
    }
  }
  // Checks whether target and/or offset have been set and returns a value
  // acceptable to Popper.js.
  getOffset() {
    const { offset, target } = this.props;
    if (target === void 0 || offset === void 0) {
      return [0, 0];
    }
    return [offset[1], offset[0]];
  }
  // Returns options customized for Popper.js.
  getModifiers() {
    return [
      {
        name: "offset",
        options: {
          offset: this.getOffset()
        }
      }
    ];
  }
  // Checks whether target is set and, if so, in what format, and returns a
  // valid reference target to position the menu relative to.
  getReference() {
    const { target } = this.props;
    if (!target) {
      this.destroyContext();
      return this.createContext();
    }
    const defaultRef = document.body;
    if (typeof target === "string") {
      return document.querySelector(target) || defaultRef;
    }
    return target || defaultRef;
  }
  // Translates UITK placement values into values acceptable to Popper.js.
  getPlacement() {
    const { placement } = this.props;
    switch (placement) {
      case "bottom-left":
        return "bottom-start";
      case "top-left":
        return "top-start";
      case "top-right":
        return "top-end";
      case "right-top":
        return "right-start";
      case "right-bottom":
        return "right-end";
      case "bottom-right":
        return "bottom-end";
      case "left-bottom":
        return "left-end";
      case "left-top":
        return "left-start";
      case "top":
      case "right":
      case "bottom":
      case "left":
        return placement;
      case "auto":
      default:
        return "bottom-start";
    }
  }
  createPopper() {
    if (this.props.visible && this.getMenuEl()) {
      const popperOptions = {
        modifiers: this.getModifiers(),
        placement: this.getPlacement(),
        strategy: this.props.fixed ? "fixed" : "absolute"
      };
      if (this.popper) {
        this.popper.setOptions(popperOptions);
        this.focus();
      } else {
        this.popper = createPopper(
          this.getReference(),
          this.getMenuEl(),
          popperOptions
        );
      }
      this.focus();
    }
  }
  destroyPopper() {
    if (this.popper) {
      this.popper.destroy();
      this.popper = null;
      this.destroyContext();
    }
  }
};

// components/menu/common/src/menu-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-menu";
var getMenuClass = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(cssClasses.root, className, overrideClasses && overrideClasses.root, globalClassName);
};
var getMenuInnerClass = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.optionsContainer,
    overrideClasses && overrideClasses.optionsContainer,
    `${globalClassName}__inner`
  );
};
var getCollapseMenuClass = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.collapseMenu,
    className,
    overrideClasses && overrideClasses.collapseMenu,
    globalClassName
  );
};
var getOptionClass = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    `${globalClassName}__option`
  );
};
var getLabelClass = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.label,
    className,
    overrideClasses && overrideClasses.label,
    `${globalClassName}__option-label`
  );
};
var getIconClass = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.icon,
    overrideClasses && overrideClasses.icon,
    `${globalClassName}__option-icon`
  );
};
var getSubmenuIconClass = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.submenuIcon,
    overrideClasses && overrideClasses.submenuIcon,
    `${globalClassName}__submenu-icon`
  );
};
var getSecondaryLabelClass = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.secondaryLabel,
    overrideClasses && overrideClasses.secondaryLabel,
    `${globalClassName}__option-secondary-label`
  );
};
var getCheckboxOptionClass = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    `${globalClassName}__checkbox-option`
  );
};
var getCheckboxOptionComponentClass = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.checkbox,
    overrideClasses && overrideClasses.checkbox,
    `${globalClassName}__checkbox-option-component`
  );
};
var getDividerClass = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    `${globalClassName}__divider`
  );
};
var getHeaderClass = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    `${globalClassName}__header`
  );
};

// components/menu/common/src/get-state-values.ts
function getStateValues(value) {
  if (value != null) {
    if (Array.isArray(value)) {
      return new Set(value);
    } else if (typeof value === "string" || !isNaN(value)) {
      return /* @__PURE__ */ new Set([value]);
    }
  }
  return /* @__PURE__ */ new Set();
}

// components/menu/common/src/menu-divider-style-sheet.ts
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var menuDividerStyleSheet = new StyleSheet(
  "menuDivider",
  (props) => {
    var _a;
    return createComponentClassDefinitions(props, createDefaultStyledClasses, (_a = props.theme.styleOverrides) == null ? void 0 : _a.menuDivider);
  }
);
function createDefaultStyledClasses({
  theme
}) {
  return {
    root: {
      margin: "2px 0 3px",
      borderTopColor: theme.border.minimal,
      borderWidth: "1px 0 0 0",
      borderStyle: "solid"
    }
  };
}

// components/menu/common/src/menu-header-style-sheet.ts
import { StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";
import {
  createComponentClassDefinitions as createComponentClassDefinitions2
} from "@gs-ux-uitoolkit-common/theme";
var menuHeaderStyleSheet = new StyleSheet2(
  "menuHeader",
  (props) => {
    var _a;
    return createComponentClassDefinitions2(
      props,
      createDefaultStyledClasses2,
      (_a = props.theme.styleOverrides) == null ? void 0 : _a.menuHeader
    );
  }
);
function createDefaultStyledClasses2({
  theme,
  size
}) {
  const color = theme.text.secondary;
  let headerVariant = "heading07";
  let headerHeight = "32px";
  if (size === "sm") {
    headerVariant = "ui02";
    headerHeight = "24px";
  } else if (size === "lg") {
    headerVariant = "heading06";
    headerHeight = "40px";
  }
  return {
    root: __spreadProps(__spreadValues({}, theme.typography[headerVariant]), {
      color,
      textTransform: "uppercase",
      letterSpacing: "0.4px",
      margin: 0,
      height: headerHeight,
      lineHeight: headerHeight,
      display: "block",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      padding: "0 16px",
      "&:focus": {
        outline: "none"
      }
    })
  };
}

// components/menu/common/src/menu-option-style-sheet.ts
import { fontWeight } from "@gs-ux-uitoolkit-common/design-system";
import { StyleSheet as StyleSheet3 } from "@gs-ux-uitoolkit-common/style";
import {
  createComponentClassDefinitions as createComponentClassDefinitions3
} from "@gs-ux-uitoolkit-common/theme";
import { rgba } from "polished";
var menuOptionStyleSheet = new StyleSheet3(
  "menuOption",
  (props) => {
    var _a;
    return createComponentClassDefinitions3(
      props,
      createDefaultStyledClasses3,
      (_a = props.theme.styleOverrides) == null ? void 0 : _a.menuOption
    );
  }
);
function createDefaultStyledClasses3({
  theme,
  size,
  selected,
  disabled,
  indented,
  submenuVisible
}) {
  const color = theme.text.secondary;
  let optionHeight = "32px";
  let optionPadding = `0 16px 0 ${indented ? "16px" : "8px"}`;
  let optionIconDimension = "20px";
  let optionLabelVariant = "body02";
  let optionIconMenuMarginRight = "-8px";
  if (size === "sm") {
    optionHeight = "28px";
    optionIconDimension = "16px";
    optionLabelVariant = "body03";
    optionIconMenuMarginRight = "-12px";
  } else if (size === "lg") {
    optionHeight = "44px";
    optionPadding = `0 24px 0 ${indented ? "20px" : "12px"}`;
    optionIconDimension = "24px";
    optionLabelVariant = "body01";
    optionIconMenuMarginRight = "-4px";
  }
  const interactionColor = theme.increaseContrast(
    theme.colorScheme.secondary,
    1
  );
  const backgroundColor = submenuVisible ? theme.surface.secondary : selected ? rgba(theme.colorScheme.primary, 0.2) : "transparent";
  const outlineStyle = submenuVisible ? { outlineWidth: 0 } : {};
  return {
    root: __spreadProps(__spreadValues({
      width: "100%",
      maxWidth: "100%",
      height: optionHeight,
      border: "none",
      borderRadius: "0px",
      backgroundColor,
      color: theme.text.primary,
      textAlign: "left",
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: optionPadding,
      opacity: disabled ? theme.state.disabledOpacity : 1
    }, outlineStyle), {
      "&:hover:not(:disabled)": {
        backgroundColor: rgba(interactionColor, 0.2),
        cursor: "pointer"
      },
      "&:active:not(:disabled)": {
        background: rgba(interactionColor, 0.4)
      },
      "&:focus-visible:not(:disabled)": {
        outline: `1px solid ${theme.text.link}`,
        outlineOffset: "-1px"
      }
    }),
    icon: {
      color,
      fontSize: optionIconDimension,
      width: optionIconDimension,
      maxWidth: optionIconDimension
    },
    submenuIcon: {
      color,
      fontSize: "20px",
      marginRight: optionIconMenuMarginRight
    },
    label: __spreadProps(__spreadValues({}, theme.typography[optionLabelVariant]), {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      flexGrow: 1,
      margin: "0 0 0 8px",
      fontWeight: selected && !disabled ? fontWeight.medium : fontWeight.normal
    }),
    secondaryLabel: __spreadProps(__spreadValues({}, theme.typography.body03), {
      color,
      margin: "0 0 0 8px",
      padding: 0,
      backgroundColor: "transparent",
      borderRadius: "0px"
    })
  };
}

// components/menu/common/src/menu-checkbox-option-style-sheet.ts
import { StyleSheet as StyleSheet4 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions4 } from "@gs-ux-uitoolkit-common/theme";
var menuCheckboxOptionStyleSheet = new StyleSheet4(
  "menu-checkbox-option",
  (props) => {
    var _a;
    return createComponentClassDefinitions4(props, createDefaultStyledClasses4, (_a = props.theme.styleOverrides) == null ? void 0 : _a.menuCheckboxOption);
  }
);
function createDefaultStyledClasses4({
  theme,
  size
}) {
  let optionHeight = "32px";
  let checkboxOptionPadding = "0 12px";
  if (size === "sm") {
    optionHeight = "28px";
    checkboxOptionPadding = "0 10px";
  } else if (size === "lg") {
    optionHeight = "44px";
    checkboxOptionPadding = "0 16px";
  }
  const interactionShades = theme.getSurfaceInteractionShades("primary");
  return {
    root: {
      width: "100%",
      maxWidth: "100%",
      height: optionHeight,
      lineHeight: optionHeight,
      display: "block",
      overflow: "hidden",
      padding: checkboxOptionPadding,
      "&:hover:not(:disabled), &:focus:not(:disabled)": {
        backgroundColor: interactionShades.hover,
        outline: "none",
        cursor: "pointer"
      }
    },
    checkbox: {
      display: "inline-block",
      width: "100%",
      "> span, > gs-label": {
        width: "100%",
        maxWidth: "100%",
        "> label": {
          display: "block",
          // refer https://gitlab.aws.site.gs.com/wf/mwp-ui/gs-ux-uitoolkit/-/merge_requests/3258/diffs
          paddingLeft: "2px",
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          lineHeight: optionHeight,
          "&:hover:not(:disabled), &:focus:not(:disabled)": {
            cursor: "pointer"
          },
          "> span:first-child": {
            position: "relative",
            top: "2px"
          }
        }
      }
    }
  };
}

// components/menu/common/src/menu-props.ts
var defaultMenuProps = {
  size: "md"
};

// components/menu/common/src/menu-context.ts
var defaultMenuContext = {
  optionClick: () => void 0,
  optionSelect: () => void 0,
  optionDeselect: () => void 0,
  submenuShow: () => void 0,
  submenuHide: () => void 0,
  addChildren: () => void 0,
  removeChildren: () => void 0,
  disabled: false,
  size: "md",
  multiple: false,
  values: /* @__PURE__ */ new Set()
};

// components/menu/common/src/menu-style-sheet.ts
import { StyleSheet as StyleSheet5 } from "@gs-ux-uitoolkit-common/style";
import { zIndex, elevationVariants } from "@gs-ux-uitoolkit-common/design-system";
import { createComponentClassDefinitions as createComponentClassDefinitions5 } from "@gs-ux-uitoolkit-common/theme";
var menuStyleSheet = new StyleSheet5("menu", (props) => {
  var _a;
  return createComponentClassDefinitions5(
    props,
    createDefaultStyledClasses5,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.menu
  );
});
var menuElevation = "05";
function createDefaultStyledClasses5({
  theme,
  size,
  visible,
  disabled
}) {
  let minHeight = "32px";
  let maxWidth = "248px";
  let minWidth = "190px";
  if (size === "sm") {
    minHeight = "28px";
    maxWidth = "180px";
    minWidth = "130px";
  } else if (size === "lg") {
    minHeight = "42px";
    maxWidth = "260px";
    minWidth = "200px";
  }
  return {
    root: __spreadProps(__spreadValues({
      backgroundColor: theme.surface.primary,
      background: theme.elevation[menuElevation].background,
      borderRadius: "2px"
    }, elevationVariants["05"]), {
      display: visible ? "block" : "none",
      position: "absolute",
      left: 0,
      top: 0,
      maxHeight: "320px",
      minHeight,
      maxWidth,
      minWidth,
      overflowX: "hidden",
      overflowY: "auto",
      zIndex: zIndex.menu,
      opacity: disabled ? theme.state.disabledOpacity : 1
    }),
    collapseMenu: {
      display: visible ? "block" : "none",
      "&:focus": {
        outline: "none"
      }
    },
    optionsContainer: {
      padding: "4px 0px"
    }
  };
}

// components/menu/common/src/submenu-context.ts
var defaultSubmenuContext = {
  isSubmenu: false
};

// components/menu/common/src/menu-attributes.ts
var MenuAttributes = class {
  constructor(props = {}, context = defaultSubmenuContext) {
    this.props = props;
    this.context = context;
  }
  updateProps(props) {
    this.props = props;
  }
  get autoFocus() {
    if (this.props.autoFocus !== void 0) {
      return this.props.autoFocus;
    }
    if (this.context.isSubmenu && this.context.autoFocus !== void 0) {
      return this.context.autoFocus;
    }
    return true;
  }
  get visible() {
    return this.props.visible !== void 0 ? this.props.visible : this.context.isSubmenu ? !!this.context.visible : false;
  }
  get fixed() {
    return this.props.fixed !== void 0 ? this.props.fixed : this.context.isSubmenu ? !!this.context.fixed : false;
  }
  get offset() {
    if (this.props.offset !== void 0) {
      return this.props.offset;
    } else if (this.context.isSubmenu && this.context.offset) {
      return this.context.offset;
    }
    return [0, 0];
  }
  get placement() {
    return this.props.placement !== void 0 ? this.props.placement : this.context.isSubmenu ? this.context.placement : "auto";
  }
  get target() {
    return this.props.target !== void 0 ? this.props.target : this.context.isSubmenu ? this.context.target : void 0;
  }
  get size() {
    return this.props.size !== void 0 ? this.props.size : this.context.isSubmenu && this.context.size ? this.context.size : "md";
  }
};
export {
  BaseStateViewModel,
  MenuAttributes,
  MenuBlurEvent,
  MenuEvent,
  MenuStateViewModel,
  defaultMenuContext,
  defaultMenuProps,
  defaultSubmenuContext,
  getCheckboxOptionClass,
  getCheckboxOptionComponentClass,
  getCollapseMenuClass,
  getDividerClass,
  getHeaderClass,
  getIconClass,
  getLabelClass,
  getMenuClass,
  getMenuInnerClass,
  getOptionClass,
  getSecondaryLabelClass,
  getStateValues,
  getSubmenuIconClass,
  hasDocument,
  hasWindow,
  menuCheckboxOptionStyleSheet,
  menuDividerStyleSheet,
  menuHeaderStyleSheet,
  menuOptionStyleSheet,
  menuStyleSheet
};
//# sourceMappingURL=index.mjs.map
